<template>
    <div :class="['image-text-container', currentStyle]" :style="cssVars">
        <div class="image-text-item" v-if="value.data && value.data.length > 0">
            <div v-for="(item, index) in value.data" :key="index">
                <div v-if="value.order === 'asc'" class="item-box">
                    <a :href="item.link || 'javascript:void(0)'" :target="item.link ? '_blank' : '_self'" :rel="item.link ? 'noopener noreferrer' : ''">
                        <img :src="decodeURIComponent(item.url)">
                    </a>
                    <p>{{ item.text }}</p>
                </div>
                <div v-else class="item-box">
                    <p>{{ item.text }}</p>
                    <a :href="item.link || 'javascript:void(0)'" :target="item.link ? '_blank' : '_self'" :rel="item.link ? 'noopener noreferrer' : ''">
                        <img :src="decodeURIComponent(item.url)">
                    </a>
                </div>
            </div>
        </div>
        <template v-else>
            <NullView tip="[图文]" :height="120" />
        </template>
    </div>
</template>

<script>
import NullView from "./NullView";

export default {
    name: 'ImageTextView',
    components: {
        NullView
    },
    props: {
        currentStyle: {
            type: String,
            default: () => ''
        },
        value: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        cssVars() {
            return {
                '--font-family': this.value.font.fontFamily,
                '--font-size': this.value.font.fontSize,
                '--font-weight': this.value.font.fontWeight,
                '--color': this.value.font.color,
                '--line-height': this.value.font.lineHeight,
                '--image-width': this.value.imageWidth + '%',
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.image-text-container {
    width: 100%;
    overflow-y: hidden;
    box-sizing: border-box;

    .image-text-item {
        display: flex;
        flex-direction: column;
        gap: 10px;

        a {
            display: block;
            margin: 0 auto;
        }

        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }

        p {
            white-space: normal;
            word-break: break-word;
            overflow-wrap: break-word;
            margin: 0;
            font-family: var(--font-family);
            font-size: var(--font-size);
            font-weight: var(--font-weight);
            color: var(--color);
            line-height: var(--line-height);
        }
    }

    // style1：图文左右分布，每行一项
    &.style1 {
        .image-text-item {
            width: 100%;

            .item-box {
                display: flex;
                flex-direction: row;
                gap: 10px;

                a {
                    width: var(--image-width);
                    flex-shrink: 0; // 防止图片被文字挤压
                }

                p {
                    flex: 1;
                    text-align: left;
                }
            }
        }
    }

    // style2：图文上下分布，每行一项，居中显示
    &.style2 {
        display: flex;
        flex-direction: column;
        align-items: center;

        .image-text-item {
            // flex-direction: column;
            align-items: center;
            text-align: center;
            width: 100%;

            .item-box {
                display: flex;
                flex-direction: column;

                a {
                    width: var(--image-width);
                }

                p {
                    flex: 1;
                    text-align: center;
                }
            }
        }
    }

    // style3：图文上下分布，每行多项，均匀分布
    &.style3 {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .image-text-item {
            width: 100%;
            display: contents;
        }

        .item-box {
            width: var(--image-width);
            display: flex;
            flex-direction: column;
            box-sizing: border-box;

            a {
                width: 100%;
            }

            p {
                text-align: center;
            }
        }
    }
}
</style>